import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';
import { useNavigate } from 'react-router-dom';

export const useLocations = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const currentSearchFormData = useSelector(state => state.searchFormData);

  const navigate = useNavigate();

  const popularNeighborhoods = [
    {
      description: 'Coyoacán',
      name: 'Coyoacán',
      imageUrl: '/images/Coyoacán.jpg',
      coords: { lat: 19.3497, lng: -99.1627 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Del Valle (Centro)',
      name: 'Del Valle (Centro)',
      imageUrl: '/images/DelValleCentro.jpg',
      coords: { lat: 19.3712, lng: -99.165 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Narvarte Centro',
      name: 'Narvarte Centro',
      imageUrl: '/images/Narvarte_Centro.jpg',
      coords: { lat: 19.378, lng: -99.1592 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Nápoles',
      name: 'Nápoles',
      imageUrl: '/images/Napoles.jpg',
      coords: { lat: 19.396, lng: -99.173 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Roma Norte',
      name: 'Roma Norte',
      imageUrl: '/images/Roma_Norte.jpg',
      coords: { lat: 19.4174, lng: -99.1685 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Polanco',
      name: 'Polanco',
      imageUrl: '/images/Polanco.jpg',
      coords: { lat: 19.4326, lng: -99.1956 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Condesa',
      name: 'Condesa',
      imageUrl: '/images/Condesa.jpg',
      coords: { lat: 19.4145, lng: -99.1737 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'San Rafael',
      name: 'San Rafael',
      imageUrl: '/images/San_Rafael.png',
      coords: { lat: 19.4475, lng: -99.164 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Escandón',
      name: 'Escandón',
      imageUrl: '/images/Escandón.jpg',
      coords: { lat: 19.4021, lng: -99.1785 },
      city: 'CDMX, Mexico',
    },
    {
      description: 'Juárez',
      name: 'Juárez',
      imageUrl: '/images/Juarez.jpg',
      coords: { lat: 19.4271, lng: -99.1621 },
      city: 'CDMX, Mexico',
    },
  ];

  const locations = [
    {
      name: 'Coyoacan',
      image:
        'https://storage.googleapis.com/popnest-static-files/spaces/garden-patio-2.jpg',
    },
    {
      name: 'Condesa',
      image:
        'https://storage.googleapis.com/popnest-static-files/spaces/4bqnZmG-Uxg6jNXInYbquNmm6A9eDMax5xeyWSQJwH8.jfif',
    },
    {
      name: 'Roma',
      image:
        'https://storage.googleapis.com/popnest-static-files/spaces/JycmrLrqJwFF9WgW7B2UwSKHxRD28idkvC_OMqw5VHY.jfif',
    },
  ];

  const goToWorkspaceMap = () => {
    //ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate('/');
  };

  const handleClickLocation = location => {
    dispatch(
      setSearchFormData({
        ...currentSearchFormData,
        coordinates: location.coords,
        locationFromSearch: location,
      }),
    );

    navigate('/');
  };

  const handleSubmit = async (values, onLocations) => {
    setLoading(true);
    setError(null);
    try {
      await onLocations(values);
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
    handleClickLocation,
    popularNeighborhoods,
    locations,
    goToWorkspaceMap,
  };
};
